import type { TherapistMatchingProfile } from "@/types/matching";

/**
 * Minimum matching profile a therapist must have to finish onboarding: at least
 * one main area of work and one population. Without these the recommendation
 * engine has nothing to score the therapist on. Shared by the wizard and
 * `handleCompleteOnboarding` so both gates agree.
 */
export function isMatchingProfileReady(profile: TherapistMatchingProfile | null | undefined): boolean {
  return Boolean(profile && profile.primaryProblemTags.length > 0 && profile.populationTags.length > 0);
}
